import { useQuery } from '@tanstack/react-query';
import { userApi } from '../api/userApi';

/** 할당 가능한 역할 항목 (UI 셀렉트 전용 최소 형태) */
export interface AssignableRole {
  code: string;
  nameKo: string;
  nameEn?: string;
}

/**
 * GET /api/eraf/roles?page=0&size=200 로부터 역할 목록을 가져온다.
 * 반환된 data 는 { code, nameKo, nameEn }[] 형태로 정규화된다(EN 로케일 라벨용 · 2026-07-15).
 * 빈 결과이거나 API 오류 시에도 UI 가 깨지지 않도록 빈 배열을 fallback 으로 제공한다.
 * queryKey 패턴: ['user-management', 'roles', 'list']
 */
export function useAssignableRoles() {
  return useQuery({
    queryKey: ['user-management', 'roles', 'list'] as const,
    queryFn: async (): Promise<AssignableRole[]> => {
      const page = await userApi.listRoles();
      return (page.content ?? []).map((r) => ({
        code: r.code,
        nameKo: r.nameKo,
        // ★nameEn 을 버리면 roleLabel 이 EN 로케일에서도 nameKo 로 폴백해 역할 셀렉트가 한글로
        // 남는다(R8-A-011 red 의 실제 원인 · 2026-07-15). 서버가 주는 nameEn 을 보존한다.
        nameEn: r.nameEn,
      }));
    },
    staleTime: 5 * 60 * 1000, // 5분 캐시 — 역할 목록은 자주 바뀌지 않음
    retry: 1,
  });
}
